<template>
  <v-app-bar
    v-if="!excluded.includes($route.path)"
    id="app-bar"
    color="#363636"
    elevation="12"
    extension-height="6"
    height="90"
  >
    <div class="d-flex align-center justify-space-between pl-3" style="width: 100%;">
      <v-app-bar-nav-icon @click.stop="toggleDrawer" />
      <div class="d-flex pr-5 justify-center w-sm-auto" :class="{ 'w-100': producer }">
        <t-badge
          v-if="producer"
          class="mr-4"
          :title="xs ? producer.data.trade_name.split(' ')[0] : producer.data.trade_name"
          :subtitle="(xs ? '' : 'ID Produtor: ') + producer.id.split('-')[0]"
          :image-src="logo!"
        />
        <t-badge
          v-if="admin"
          :title="(xs && producer) ? admin.name.split(' ')[0] : admin.name"
          :subtitle="rolesBadgeText"
          :pill-color="theme.current.value.colors.primary"
        />
      </div>
    </div>
    <template #extension>
      <div class="d-flex flex-column justify-end" :style="`background-color: ${theme.current.value.colors.primary}; width: 100%; height: 10px`">
        <v-progress-linear
          v-if="$loader.loading"
          color="grey"
          indeterminate
          class="position-relative"
          style="bottom: -4px; top: unset"
        />
      </div>
    </template>
  </v-app-bar>
</template>

<script lang="ts" setup>
import TBadge from './TBadge.vue'
import { computed } from 'vue'
import { useAdminStore } from '../stores/admin'
import { useProducerStore } from '../stores/producer'
import { useDrawerStore } from '@/stores/drawer'
import { useTheme } from 'vuetify/lib/composables/theme'
import { useDisplay } from 'vuetify/lib/composables/display'

const theme = useTheme()

const { mobile: isMobile, xs } = useDisplay()

const drawer = useDrawerStore()

const excluded = [ '/login' ]

const producer = computed(() => useProducerStore().producer)
const admin = computed(() => useAdminStore().admin)

const logo = computed(() => producer.value?.images?.find(image => image.tag === 'producer-logo')?.url)

// Choose a role title to display on the badge
const rolesBadgeText = computed(() => {
  if (!admin.value?.roles?.length) return admin.value?.role ?? ''

  const prefix = (xs.value && producer) ? '' : 'Cargo: '

  let chosen = admin.value.roles[0]

  for (const role of admin.value.roles) {
    if (role.name === 'master') return prefix + 'master'
    if (role.title[0] < chosen.title[0]) chosen = role
  }

  return prefix + chosen.title.toLocaleLowerCase()
})

function toggleDrawer() {
  if (isMobile.value) {
    drawer.toggleMobile()
  } else {
    drawer.toggleDesktop()
  }
}

</script>

<style lang="scss">
.container {
  width: 100%;
  padding-left: 36px;
  padding-right: 36px;

  display: flex;
  justify-content: space-between;

  .admin {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
